const ROOT_PICKER_INJECTION_KEY = /* @__PURE__ */ Symbol("rootPickerContextKey");
const ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY = "ElIsDefaultFormat";

export { ROOT_PICKER_INJECTION_KEY, ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY };
//# sourceMappingURL=constants.mjs.map
